<template>
  <v-container fluid>
  <div>
    <!-- Mobile Layout -->
    <TablesMobile v-if="isMobile" />

    <!-- Desktop Layout -->
    <TablesDesktop v-else />
  </div>
  </v-container>
</template>

<script>
import TablesMobile from "./mobile.vue";
import TablesDesktop from "./desktop.vue";

export default {
  name: "TablesIndex",
  components: {
    TablesMobile,
    TablesDesktop,
  },
  computed: {
    // Detect mobile vs desktop
    isMobile() {
      return (
        this.$vuetify.breakpoint.mobile || this.$vuetify.breakpoint.smAndDown
      );
    },
  },
};
</script>

<style scoped>
/* No styles needed here - styles are in child components */
</style>
